import React from 'react'
import { css } from '@emotion/css'
import {
  HistogramViewItem,
  processHistogramViewItem,
  VrHistogramView
} from '../vr-histogram-view'
import { HistogramViewProps } from '../../shared'
import { Thermometer } from '../../../../../../legacy-design-system/thermometer'

const e2eTestIdPrefix = 'value-reporting-vulnerabilities-type-breakdown'

const cssLabel = css`
  margin-left: 10px;
  max-width: 160px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

export interface NameValueType {
  readonly displayName: string
  readonly value: string
}

/**
 * The histogram view label
 */
function ViewLabel({ item }: HistogramViewItem, index: number) {
  const { displayName } = item as NameValueType

  return (
    <div
      className={css`
        display: flex;
      `}
      data-e2e={`${e2eTestIdPrefix}-label-${index}`}
      key={displayName}
    >
      {`${index + 1}.`}
      <div className={cssLabel}>{displayName}</div>
    </div>
  )
}

/**
 * The histogram view thermometer
 */
function ViewThermometer({ item, ratio }: HistogramViewItem) {
  const { displayName } = item as NameValueType

  return (
    <Thermometer
      fillRatio={ratio}
      e2eTestId={`${e2eTestIdPrefix}-thermometer-${displayName}`}
      key={displayName}
    />
  )
}

/**
 * This is the view for vulnerability rule types within the value reporting histogram module.
 */
export function HistogramViewRuleType({
  organizationUuid,
  selectedFacets,
  histogramType,
  data: { vulnerabilityType }
}: HistogramViewProps) {
  return (
    <VrHistogramView
      organizationUuid={organizationUuid}
      selectedFacets={selectedFacets}
      histogramType={histogramType}
      data={vulnerabilityType}
      e2eTestId="value-reporting-vulnerabilities-type-breakdown"
      renderLabel={ViewLabel}
      renderThermometer={ViewThermometer}
      processSummary={processViewSummaryData}
    />
  )
}

/**
 * Processes a set of raw histogram data and converts it to sorted view items.
 */
export function processViewSummaryData(
  items: NameValueType[],
  counts: number[],
  ratios: number[]
): Array<HistogramViewItem> {
  //  Only show the top 5 elements
  return items
    .slice(0, 5)
    .map((item) => processHistogramViewItem(item, items, counts, ratios))
}
